/**
 * AmbientBlobs — soft, drifting color blobs used behind hero sections.
 * Bright theme, no purple/blue galaxy stuff.
 */
export function AmbientBlobs({ className = "" }) {
  return (
    <div
      className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}
      aria-hidden="true"
    >
      <div
        className="ambient-blob animate-drift"
        style={{
          width: 520,
          height: 520,
          top: "-12%",
          left: "-8%",
          background:
            "radial-gradient(circle at 30% 30%, rgba(255,79,39,0.5), rgba(255,79,39,0) 70%)",
        }}
      />
      <div
        className="ambient-blob animate-drift"
        style={{
          width: 460,
          height: 460,
          top: "20%",
          right: "-10%",
          background:
            "radial-gradient(circle at 50% 50%, rgba(225,255,0,0.45), rgba(225,255,0,0) 70%)",
          animationDelay: "-6s",
        }}
      />
      <div
        className="ambient-blob animate-drift"
        style={{
          width: 360,
          height: 360,
          bottom: "-14%",
          left: "30%",
          background:
            "radial-gradient(circle at 50% 50%, rgba(0,214,143,0.32), rgba(0,214,143,0) 70%)",
          animationDelay: "-10s",
        }}
      />
    </div>
  );
}
